import { FileRouteTypes } from '../routeTree.gen';

export const TRADE_ROUTE_URL = '/trade/' as const;
export const ASSET_ROUTE_URL = '/trade/$asset' as const;
export const PORTFOLIO_ROUTE_URL = '/portfolio' as const;
export const PORTFOLIO_OVERVIEW_ROUTE_URL = '/portfolio/overview' as const;
export const PORTFOLIO_POSITIONS_ROUTE_URL = '/portfolio/positions' as const;
export const PORTFOLIO_ORDERS_ROUTE_URL = '/portfolio/orders' as const;
export const PORTFOLIO_TRADES_ROUTE_URL = '/portfolio/trades' as const;
export const PORTFOLIO_FUNDING_ROUTE_URL = '/portfolio/funding' as const;
export const PORTFOLIO_SESSIONS_ROUTE_URL = '/portfolio/sessions' as const;
export const PRIVACY_ROUTE = '/privacy' as const;
export const TERMS_ROUTE = '/terms' as const;

// Tab routes
export const PORTFOLIO_TRADES_ORDER_HISTORY_TAB_URL =
  `${PORTFOLIO_TRADES_ROUTE_URL}?tableTab=orderHistory` as FileRouteTypes['fullPaths'];
export const PORTFOLIO_TRADES_CLOSED_PNL_TAB_URL =
  `${PORTFOLIO_TRADES_ROUTE_URL}?tableTab=pnl` as FileRouteTypes['fullPaths'];
export const PORTFOLIO_TRADES_TRADE_HISTORY_TAB_URL =
  `${PORTFOLIO_TRADES_ROUTE_URL}?tableTab=tradeHistory` as FileRouteTypes['fullPaths'];
